export const SHOW_SALOON_DASHBOARD_IN_NAV_MENU = true;
export const IS_SALOON_OWNER_ROLE_ENABLED = false;
